@if(isDisabled){
<app-loader></app-loader>
}
<div class="card">
    <div class="card-header">
        <div class="row">
            <div class="col-auto">
                Employee Filter
            </div>
            <div class="col"></div>
            <div class="col-auto">
                <button type="button" class="btn btn-sm btn-outline-primary ms-1" [disabled]="isDisabled"
                    (click)="isCollapsed = !isCollapsed" [attr.aria-expanded]="!isCollapsed"
                    aria-controls="collapseFilter">
                    <i class="{{isCollapsed ? 'bi bi-caret-down-fill' : 'bi bi-caret-up-fill'}}" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Search':'Loading...'}}
                </button>
            </div>
        </div>
    </div>
    <div class="card-body">
        <div #collapse="ngbCollapse" [(ngbCollapse)]="isCollapsed">
            <div class="row">
                <div class="col-md-6">
                    <label class="Label">Branch</label>
                    <ng-select name="branch" [items]="Branchs" bindLabel="BranchName" bindValue="BranchMasterID"
                        [(ngModel)]="Filter.BranchId" (change)="ComboLoad('Client')" placeholder="Select Branch">
                    </ng-select>
                </div>

                <div class="col-md-6">
                    <label class="Label">Client</label>
                    <ng-select name="client" [items]="Clients" bindLabel="ClientGroupName"
                        bindValue="ClientGroupMasterID" [(ngModel)]="Filter.ClientId" (change)="ComboLoad('Site')"
                        placeholder="Select Client">
                    </ng-select>
                </div>

                <div class="col-md-6">
                    <label class="Label">Site</label>
                    <ng-select name="site" [items]="Sites" bindLabel="SiteName" bindValue="SiteMasterID"
                        [(ngModel)]="Filter.SiteId" placeholder="Select Site">
                    </ng-select>
                </div>

                <div class="col-md-6">
                    <label class="Label">Employee Code</label>
                    <input name="Employeecode" type="text" class="form-control" [(ngModel)]="Filter.EmpCode"
                        placeholder="Employee Code" />
                </div>

                <div class="col-md-6">
                    <label class="Label">Employee Name</label>
                    <input name="Employeecode" type="text" class="form-control" [(ngModel)]="Filter.EmpName"
                        placeholder="Employee Code" />
                </div>

                <div class="col-auto mt-4">
                    <button (click)="ComboLoad('FilterOnEmpCodeName')" class="btn btn-primary btn-sm"> <i
                            class="bi bi-search"></i> Search</button>
                </div>
            </div>
            <hr>
        </div>

        <div class="mt-4">
            <table datatable [dtOptions]="dtoptions" [dtTrigger]="dtTrigger"
                class="customeDatatable table table-bordered table-hover">
                <thead>
                    <tr>
                        <th>Employee</th>
                        <!-- <th>EmpCode</th> -->
                        <th>Client Name</th>
                        <th>Site Name</th>
                        <th>Shift</th>
                        <th>Duty</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let data of TableDatas; let i = index" (dblclick)="onDoubleClick(data)"
                        class="cursor-pointer" style="font-size: 11px;">
                        <!-- <td>{{data['Name']}}</td> -->
                        <td>
                            <div class="row no-gutters" style="align-items: center;width: 300px;">
                                <div class="col userdetail">
                                    <span class="text-label">{{data['Name']}}</span><br />
                                    <span class="text-label-light">#{{data['EmpCode']}}</span><br />
                                    <span class="text-label-light">{{data['Designation']}}</span>
                                </div>
                            </div>
                        </td>
                        <!-- <td>{{data['EmpCode']}}</td> -->
                        <td>{{data['ClientName']}}</td>
                        <td>{{data['SiteName']}}</td>
                        <td>{{data['ShiftName']}}</td>
                        <td>{{data['DutyName']}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div class="card-footer">
        <div class="row">
            <div class="col"></div>
            <div class="col-auto">
                <button (click)="close()" class="btn btn-outline-primary btn-sm">
                    Close
                </button>
            </div>
        </div>
    </div>
</div>